<template>
  <div>
    <form @submit.prevent="save">
      <div class="mb-3">
        <label class="form-label">Shop Name</label>
        <input
          v-model="form.name"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.name }"
          placeholder="Enter shop name"
        >
        <div v-if="errors.name" class="text-danger">
          {{ errors.name[0] }}
        </div>
      </div>

      <div class="mb-3">
        <label class="form-label">Address</label>
        <input
          v-model="form.address"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.address }"
          placeholder="Enter shop address"
        >
        <div v-if="errors.address" class="text-danger">
          {{ errors.address[0] }}
        </div>
      </div>

      <div class="modal-footer-btn">
        <button type="button" class="btn btn-cancel me-2" data-bs-dismiss="modal">Cancel</button>
        <button type="submit" class="btn btn-submit" :disabled="loading">
          <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
          Create
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { showSuccessMessage, showErrorMessage } from '../utils/notifications.js';

export default {
  name: 'ShopCreate',

  data() {
    return {
      form: {
        name: '',
        address: ''
      },
      errors: {},
      loading: false
    };
  },

  mounted() {
    console.log('ShopCreate component mounted');

    // Mark element as mounted
    this.$el.closest('[data-vue-component]')?.classList.add('vue-mounted');
  },

  methods: {
    async save() {
      this.loading = true;
      this.errors = {};

      try {
        const response = await this.$http.post('/api/shops', this.form);

        if (response.data.success) {
          this.showSuccessMessage(response.data.message);

          // Reset form
          this.resetForm();

          // Close modal
          const modal = this.$el.closest('.modal');
          if (modal) {
            const modalInstance = bootstrap.Modal.getInstance(modal);
            if (modalInstance) {
              modalInstance.hide();
            }
          }

          // Emit event for parent components
          this.$emit('shop-created', response.data.shop);

          // Redirect if specified
          if (response.data.redirect_url) {
            window.location.href = response.data.redirect_url;
          } else {
            // Refresh page to show new shop
            window.location.reload();
          }
        }
      } catch (error) {
        console.error('Shop creation failed:', error);

        if (error.response?.status === 422) {
          this.errors = error.response.data.errors || {};
          this.showErrorMessage('Please check the form for errors');
        } else {
          this.showErrorMessage(
            error.response?.data?.message || 'An error occurred while creating the shop'
          );
        }
      } finally {
        this.loading = false;
      }
    },

    resetForm() {
      this.form = {
        name: '',
        address: ''
      };
      this.errors = {};
    },

    showSuccessMessage,
    showErrorMessage
  }
}
</script>

<style scoped>
.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
}

.is-invalid {
  border-color: #dc3545;
}

.text-danger {
  color: #dc3545 !important;
  font-size: 0.875rem;
  margin-top: 0.25rem;
}
</style>
